import { useEffect, useState } from "react";
import { Search, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

const Row = ({ r, done }) => (
  <div className="flex items-center justify-between gap-3 px-3 py-2.5 text-sm">
    <div className="min-w-0">
      <div className="truncate font-semibold">{r.athlete_name}</div>
      <div className="truncate text-xs text-slate-400">{r.license_number} · {(r.categories || []).join(", ")}{r.sector_name ? ` · ${r.sector_name}` : ""}</div>
    </div>
    <span className="shrink-0 text-xs text-slate-400">
      {done ? new Date(r.registered_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : r.membership_number}
    </span>
  </div>
);

export function RosterPanel({ eventId, refreshKey, onData }) {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("registered");
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!eventId) return undefined;
    let alive = true;
    const load = () => api.get(`/events/${eventId}/roster`).then((r) => { if (alive) { setData(r.data); onData?.(r.data); } }).catch(() => {});
    setData(null);
    load();
    const t = setInterval(load, 10000);
    return () => { alive = false; clearInterval(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, refreshKey]);

  if (!eventId) return null;
  const rows = (data?.[tab] || []).filter((r) => r.athlete_name.toLowerCase().includes(q.toLowerCase()) || (r.license_number || "").toLowerCase().includes(q.toLowerCase()));
  const tabBtn = (key, label, n, cls) => (
    <button onClick={() => setTab(key)} data-testid={`roster-tab-${key}`}
      className={`flex-1 rounded-lg px-3 py-2.5 text-sm font-bold transition-colors ${tab === key ? cls : "text-slate-400 hover:text-white"}`}>
      {label} <span data-testid={`roster-count-${key}`}>{n ?? "…"}</span>
    </button>
  );

  return (
    <div className="mt-6" data-testid="roster-panel">
      <div className="mb-2 flex items-center justify-between">
        <div className="eyebrow !text-slate-400">Lista iscritti gara · tempo reale</div>
        {data && <span className="flex items-center gap-1 text-xs text-slate-500"><RefreshCw className="h-3 w-3" />{new Date(data.updated_at).toLocaleTimeString("it-IT")}</span>}
      </div>
      <div className="flex gap-1 rounded-xl border border-slate-800 bg-slate-900 p-1">
        {tabBtn("registered", "Ammessi registrati", data?.registered.length, "bg-emerald-600 text-white")}
        {tabBtn("missing", "Mancanti", data?.missing.length, "bg-amber-500 text-slate-950")}
      </div>
      <div className="relative mt-2">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca atleta o licenza" data-testid="roster-search-input"
          className="h-10 w-full rounded-lg border border-slate-700 bg-slate-900 pl-9 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/40" />
      </div>
      <div className="mt-2 max-h-80 divide-y divide-slate-800 overflow-y-auto rounded-xl border border-slate-800 bg-slate-900" data-testid={`roster-list-${tab}`}>
        {!data ? <div className="p-4 text-sm text-slate-500">Caricamento…</div>
          : rows.length === 0 ? <div className="p-4 text-sm text-slate-500">{tab === "registered" ? "Nessun atleta registrato." : "Nessun atleta mancante: tutti gli abilitati sono registrati."}</div>
          : rows.map((r) => <Row key={r.athlete_id} r={r} done={tab === "registered"} />)}
      </div>
      {tab === "missing" && <div className="mt-2 text-xs text-slate-500">Atleti di qualsiasi settore con licenza attiva e compatibile con questa gara, non ancora registrati.</div>}
    </div>
  );
}
